import styled from 'styled-components';
import { colors, dimensions } from 'modules/common/styles';
import { SortItem } from 'modules/theme';
import { typography } from 'modules/theme';

const imageSize = 30;
const unitSpace = `${dimensions.unitSpacing}px`;

const Members = styled.div`
  padding-top: ${dimensions.unitSpacing - 5}px;
`;

const MemberImg = styled.img`
  width: ${imageSize}px;
  height: ${imageSize}px;
  border-radius: ${imageSize / 2}px;
  background: ${colors.bgActive};
  border: 2px solid ${colors.colorWhite};
  margin-left: -8px;

  &:first-child {
    margin-left: 0;
  }
`;

const DataWrapperClass = styled.div`
  section.sc-iELTvK.dgWnOn {
    background: #fff;
    margin-left: 20px;
    margin-right: 20px;
  }
  section.sc-jtRfpW.daxgFZ {
    margin-right: 20px;
  }
  section.sc-iELTvK.dstvIj {
    background: #fff;
    margin-left: 20px;
  }
  @media (max-width: 760px)
  {
    // margin-left: -70px;
  }
`;

const More = MemberImg.withComponent('span').extend`
  color: ${colors.colorWhite};
  text-align: center;
  vertical-align: middle;
  font-size: ${dimensions.unitSpacing}px;
  background: ${colors.colorCoreLightGray};
  display: inline-block;
  line-height: ${dimensions.coreSpacing + 6}px;
  cursor: pointer;
`;

const QuestionsContainer = styled.div`
  h3 {
    text-transform: uppercase;
    color: ${colors.colorCoreLightGray};
    font-size: 11px;
    padding: 10px 20px;
    margin: 0;
    height: 100%;
  }

  ${SortItem} {
    margin-bottom: -1px;
    border: 0;
    border-top: 1px solid ${colors.borderPrimary};
    border-bottom: 1px solid ${colors.borderPrimary};
    padding-left: 20px;
    padding-right: 20px;
  }
`;

const InsightWrapper = styled.div`
  // position: absolute;
  // right: 0;
  // top: 0;
  // bottom: 0;
  // left: 0;
  // display: flex;
  // flex-direction: column;
  // flex: 1;
  // min-width: 480px;
  // border-radius: 20px;
  // margin-right: 20px;
  // margin-left: 20px;
  // width: 91%;
`;

const InsightContent = styled.div`
  overflow: auto;

  .summ h5 {
    margin-left: 20px;
  }
`;

const InsightRow = styled.div`
  position: relative;
  // margin-bottom: 24px;

  div {
    margin: 0px;
  }
  .titleCard h5 {
    padding: 0;
    margin: 0;
  }
`;

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  @media (max-width: 760px)
  {
    display: block;
  }
`;

const FlexItem = styled.div`
  flex: 1;
  margin: 0;
  margin-left: ${dimensions.coreSpacing}px;

  @media (max-width: 760px)
  {
    margin-left: 0px;
  }

  &:first-child {
    margin-left: 0;
  }

  .form-control {
    box-shadow: none;
    border-radius: 4px;
    border: 1px solid ${colors.themeBlue};
    background: none;
    /* border-bottom: 1px solid ${colors.colorShadowGray}; */
    padding: 7px 14px;
    font-size: 13px;
    height:50px;
    &:focus {
      box-shadow: none;
      border-color: ${colors.colorPrimary};
    }
  }

  
`;

const ItemSearch = styled.div`
  input {
    // border-left: none;
    // border-right: none;
    // border-top: none;
    // height: 34px;
    padding: 10px;
    // border-radius: 0px;
  }
`;

const InsightFilter = styled.div`
  padding: 20px 30px;
  // border-bottom: 1px solid ${colors.borderPrimary};
  background: ${colors.colorWhite};
  border-radius: 20px;

  h5 {
    margin-top: 0;
  }
`;

const InsightTitle = styled.h5`
  text-transform: uppercase;
  font-weight: 500;
  padding: ${dimensions.unitSpacing}px 0;
  // margin: ${dimensions.coreSpacing}px 0 ${dimensions.unitSpacing}px;
  font-weight: 700;
  color: ${colors.colorPrimary}

  span {
    margin-left: ${dimensions.unitSpacing}px;
  }
`;

const InlineItems = styled.div`
  display: flex;
  margin-bottom: ${unitSpace};
  align-items: center;
  justify-content: space-between;

  > div {
    margin-right: ${unitSpace};
  }
`;

const ChartWrapper = styled.div`
  padding: ${dimensions.coreSpacing}px;
  border: 1px solid ${colors.borderPrimary};
  border-radius: 10px;
  background: ${colors.colorWhite};
  width: 100%;
  height: ${props => (props.height ? `${props.height}px` : 'auto')}
  position: relative;
  overflow: hidden;
`;
const CustomButtonWrapper = styled.div`
    span {
      @media (max-width: 768px) {
          display: none;
      }
    }

`;

const LoaderWrapper = ChartWrapper.extend`
  padding: ${dimensions.coreSpacing * 2}px;
`;

export {
  MemberImg,
  Members,
  More,
  DataWrapperClass,
  QuestionsContainer,
  InsightWrapper,
  FlexRow,
  FlexItem,
  InsightFilter,
  InsightTitle,
  InlineItems,
  InsightContent,
  InsightRow,
  LoaderWrapper,
  ChartWrapper,
  ItemSearch,
  CustomButtonWrapper
};



// WEBPACK FOOTER //
// ./src/modules/screens/reporting/styles.js